"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractKitProvider = exports.ContractKitContext = void 0;
var react_1 = __importStar(require("react"));
var connectors_1 = require("./connectors");
var constants_1 = require("./constants");
var contract_kit_reducer_1 = require("./contract-kit-reducer");
var modals_1 = require("./modals");
var helpers_1 = require("./utils/helpers");
var useIsMounted_1 = require("./utils/useIsMounted");
var initialState = {
    connector: new connectors_1.UnauthenticatedConnector(constants_1.Mainnet),
    connectorInitError: null,
    dapp: {
        name: 'Celo dApp',
        description: 'Celo dApp',
        url: 'https://celo.org',
        icon: 'https://celo.org/favicon.ico',
    },
    network: constants_1.Mainnet,
    networks: [],
    pendingActionCount: 0,
    address: null,
    connectionCallback: null,
};
exports.ContractKitContext = react_1.createContext([
    initialState,
    function () { return undefined; },
]);
var ContractKitProvider = function (_a) {
    var _b;
    var children = _a.children, connectModal = _a.connectModal, actionModal = _a.actionModal, dapp = _a.dapp, _c = _a.networks, networks = _c === void 0 ? [] : _c;
    var isMountedRef = useIsMounted_1.useIsMounted();
    var _d = react_1.useReducer(contract_kit_reducer_1.contractKitReducer, __assign(__assign(__assign({}, initialState), helpers_1.loadPreviousConfig()), { networks: networks, dapp: __assign(__assign({}, dapp), { icon: (_b = dapp.icon) !== null && _b !== void 0 ? _b : dapp.url + "/favicon.ico" }) })), state = _d[0], _dispatch = _d[1];
    var dispatch = react_1.useCallback(function (type) {
        var payload = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            payload[_i - 1] = arguments[_i];
        }
        if (isMountedRef.current) {
            _dispatch({ type: type, payload: payload[0] });
        }
    }, [isMountedRef]);
    return (react_1.default.createElement(exports.ContractKitContext.Provider, { value: [state, dispatch] },
        react_1.default.createElement(modals_1.ConnectModal, __assign({}, connectModal)),
        react_1.default.createElement(modals_1.ActionModal, __assign({}, actionModal)),
        children));
};
exports.ContractKitProvider = ContractKitProvider;
//# sourceMappingURL=contract-kit-provider.js.map